import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Footer.module.css";

const Footer = () => {
  return (
    <footer className={`${styles.footer} mt-4`}>
      <div className="container text-center">
        <div className={styles.footerContent}>
          <div className={styles.footerColumn}>
            <h5>Resources</h5>
            <ul className={styles.list}>
              <li>
                <a href="https://waldiez.io" target="_blank">
                  Website
                </a>
              </li>
              <li>
                <a href="https://docs.waldiez.io" target="_blank">
                  Docs
                </a>
              </li>
              <li>
                <a href="https://docs.waldiez.io/examples/index.html" target="_blank">
                  Examples
                </a>
              </li>
              <li>
                <a href="https://github.com/waldiez/waldiez" target="_blank">
                  GitHub
                </a>
              </li>
              <li>
                <a href="https://ag2.ai/" target="_blank">
                  AG2
                </a>
              </li>
            </ul>
          </div>
          <div className={styles.footerColumn}>
            <h5>Channels</h5>
            <ul className={styles.list}>
              <li>
                <a
                  href="https://www.linkedin.com/company/waldiez"
                  target="_blank"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/@waldiez" target="_blank">
                  YouTube
                </a>
              </li>
              <li>
                <a href="https://x.com/Waldiez_io" target="_blank">
                  X
                </a>
              </li>
            </ul>
          </div>
          <div className={styles.footerColumn}>
            <h5>Legal</h5>
            <ul className={styles.list}>
              <li>
                <Link to="/terms-privacy">Terms & Privacy</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <p>© 2024-2026 Waldiez. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
